import React, { type ComponentProps } from 'react';
import { StyleProp, StyleSheet, ViewStyle, View } from 'react-native';
import { useStyle } from 'react-native-style-utilities';

import { theme } from '@garnish/constants';

import { HorizontalScrollRail, useContainerSpacing, useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const ReorderRailList = (props: ReorderRailListProps) => {
  const { children, style, contentContainerStyle } = props;

  const { match } = useResponsive();
  const containerSpacing = useContainerSpacing();

  // ─── Styles ──────────────────────────────────────────────────────────

  const extraOffset = match([theme.spacing['1'], theme.spacing['3']]);

  const railDynamicStyles = useStyle(
    () => ({ paddingHorizontal: containerSpacing - extraOffset }),
    [containerSpacing, extraOffset],
  );

  // ─────────────────────────────────────────────────────────────────────

  return (
    <View style={styles.container}>
      <HorizontalScrollRail
        showNavControls={false}
        gap={0}
        outerOffset={0}
        style={style}
        contentContainerStyle={[railDynamicStyles, contentContainerStyle]}
      >
        {children}
      </HorizontalScrollRail>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type ReorderRailListProps = {
  children: HorizontalScrollRailProps['children'];
  style?: StyleProp<ViewStyle>;
  contentContainerStyle?: StyleProp<ViewStyle>;
};

type HorizontalScrollRailProps = ComponentProps<typeof HorizontalScrollRail>;
